Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.ValuesMapper
  @TYPE = 'values'

  constructor: (primaryKey, secondaryKey) ->
    @type = CustomerVisualMode.Mappers.ValuesMapper.TYPE
    @primaryKey = primaryKey
    @secondaryKey = secondaryKey
    @primaryLogicKey = primaryKey + '_logic'
    @secondaryLogicKey = secondaryKey + '_logic'

  canHandle: (type) ->
    type == @type

  mapToCompositeFilter: (values) ->
    included = {type: @type}
    primary = @_mapIncludedKey('primary', values[@primaryKey], values[@primaryLogicKey])
    secondary = @_mapIncludedKey('secondary', values[@secondaryKey], values[@secondaryLogicKey])
    return {} if primary.length == 0 && secondary.length == 0

    {included: _.extend(included, primary, secondary)}

  mapToSearchQuery: (intelligentGroups) ->
    included = intelligentGroups.included
    return {} unless included

    primary = @_mapIncludedKeyToSearchQuery('primary', @primaryKey, @primaryLogicKey, included)
    secondary = @_mapIncludedKeyToSearchQuery('secondary', @secondaryKey, @secondaryLogicKey, included)
    _.extend(primary, secondary)
    
  _mapIncludedKeyToSearchQuery: (key, valuesKey, logicKey, values) ->
    return {} unless values[key]

    {"#{valuesKey}": values[key].values, "#{logicKey}": values[key].operator || 'or'}

  _mapIncludedKey: (key, values, logic) ->
    json = {}
    return json if values && values.length == 0

    {
      "#{key}": {
        values: values,
        operator: logic?.toLowerCase() || 'or'
      }
    }
